<template>
  <a-drawer title="选择卡片" placement="right" width="716px" destroy-on-close v-bind="$attrs" v-model:open="open">
    <a-list :data-source="editor.material.cards.cards" :grid="{gutter: [16,0],column:3}"
            :pagination="{defaultPageSize:12,showSizeChanger:false,onChange: (a:number,b:number) => editor.material.cards.loadPage(a,b)}">
      <template #renderItem="{item}">
        <a-list-item>
          <check-square :check="false" @update:check="onCheck($event,item)">
            <a-spin :spinning="item.active.loading">
              <a-flex vertical justify="between-space" class="card">
                <img :src="item.active.header" alt=""/>
                <a-flex :style="{backgroundImage:`url(${item.active.content})`}" class="card__body" align="center"
                        justify="center">
                  {{ item.active.loading ? '加载中' : '演示内容' }}
                </a-flex>
                <img :src="item.data.footer_image_url" alt=""/>
              </a-flex>
            </a-spin>
          </check-square>
        </a-list-item>
      </template>
    </a-list>
  </a-drawer>
</template>

<script setup lang="ts">
import {computed, watch} from "vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import CheckSquare from "@/views/share/CheckSquare.vue";
import {CardPreview} from "@/model/materials/card_preview";

const editor = useRoute().meta.editor as AEditor;
const emit = defineEmits(['on-pick', 'update:open'])
const props = defineProps<{ open: boolean }>();
const open = computed({get: () => props.open, set: (v) => emit('update:open', v)})

watch(open, o => {
  if (o) editor.material.cards.loadPage(1, 12)
})

const onCheck = (c: boolean, cp: CardPreview) => {
  if (c) {
    emit('on-pick', cp.data)
    open.value = false
  }
}
</script>

<style scoped lang="sass">
:deep(.ant-list-item)
  padding: 0 !important

.card
  aspect-ratio: 1 / 1
  padding: 8px

  > .card__body
    flex: 1 1 auto
    background-repeat: repeat-y
    background-size: 100% auto
    background-attachment: scroll
    color: #222222

  > img
    max-width: 100%
    height: auto
    display: block
</style>